var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#002f5f",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 256 242",
    enableBackground: "new 0 0 256 242",
    xmlSpace: "preserve",
    stroke: "#002f5f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.327,30.668c11.331,0,20.516,9.185,20.516,20.516S119.657,71.7,108.327,71.7S87.81,62.515,87.81,51.184 S96.996,30.668,108.327,30.668z M33.069,154.994l-0.189-0.189l0,0c-0.851-0.567-1.607-1.04-2.269-1.796l2.269,26L4.327,219.474 c-4.065,5.862-2.647,13.804,3.025,17.869c5.862,4.065,13.804,2.647,17.869-3.025l30.822-44.436c1.607-2.269,2.647-5.295,2.269-8.32 l-1.04-12.574L33.069,154.994z M117.876,239.612h122.341l-22.88-71.381c0,0-12.953,3.215-38.574,30.443 c-0.567,0.567-1.229,1.229-1.796,1.796l-61.832-35.738c1.04-1.985,1.229-4.255,0.851-6.713L94.05,76.711 c-1.796-7.942-8.887-13.993-17.207-13.993H35.905c-3.025,0-6.051,1.607-7.753,4.255L7.731,102.427 c-2.647,4.255-1.04,9.738,3.215,12.196l22.88,13.142L30.8,132.87c-3.687,6.051-1.607,13.804,4.633,17.207L86.77,179.67v46.894 c0,7.091,5.673,12.764,12.764,12.764s12.764-5.673,12.764-12.764v-53.512l56.821,32.902c-11.724,6.713-25.149,7.942-34.698,13.614 C122.697,226.564,117.876,239.612,117.876,239.612z M38.174,120.296l-15.033-8.698l0,0l17.869-30.822h20.044L38.174,120.296z M71.171,139.394l14.182-24.771l10.589,38.952L71.171,139.394z M254,53.634c0,3.239-2.626,5.953-5.953,5.953 c-1.751,0-3.414-0.788-4.465-2.014l-7.004-6.479v55.594h-25.065l-21.578,0h-25.41V50.658l-8.055,7.267 c-1.051,1.051-2.539,1.663-4.115,1.663c-3.239,0-5.953-2.626-5.953-5.953c0-1.839,0.875-3.59,2.189-4.64L200.77,2.33l15.671,14.271 V4.519h13.395v24.339l22.675,20.749C253.475,50.658,254,52.058,254,53.634z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon4);
export default __webpack_public_path__ + "static/media/service-icon4.e1bea39ee62ae783b8137fb06be765e6.svg";
export { ForwardRef as ReactComponent };